// extracted by mini-css-extract-plugin
module.exports = {"lozenge":"nIMaqiiI","close":"_1PlABVsA"};